<div class="sidebar">
  <header class="header">
    <ng-content select="[xHeader]"></ng-content>
  </header>

  <div class="menu">
    <ng-content select="[xMenu]"></ng-content>
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>

  <div class="footer">
    <ng-content select="[xFooter]"></ng-content>
  </div>

  <x-loader *ngIf="rc.routeTransition$ | async"></x-loader>
</div>
